import Api from "@/services/Api";

export default {
  async Upload(data) {
    var result = await Api.execute("post", `/upload`, data);
    return result;
  },
  async Login(data) {
    var result = await Api.execute("post", `/login`, data);
    return result;
  },
  async StartGame(data) {
    var result = await Api.execute("post", `/start`, data);
    return result;
  },
  async Level1Finished(data) {
    var result = await Api.execute("post", `/level1finish`, data);
    return result;
  },
  async Level2Finished(data) {
    var result = await Api.execute("post", `/level2finish`, data);
    return result;
  },
  async Shake(data) {
    var result = await Api.execute("post", `/shake`, data);
    return result;
  },
  async Lottery(data) {
    var result = await Api.execute("post", `/lottery`, data);
    return result;
  },
  async Log(data) {
    var result = await Api.execute("post", `/log`, data);
    return result;
  }
};
